<template>
<div class="header">
  <div class="header-container">

    <div class="nav-wrapper">

      <div class="title-logo">
        <router-link to="home">
          <p>中国整体治療研究所認定</p>
          <h1><img class="" src="/images/logo.png">とだ整体&nbsp;<span>ー中国整体術ー</span></h1>
        </router-link>
      </div>

      <div class="nav">
        <ul class="navbar">
          <li><router-link to="faq">よくある質問</router-link></li>
          <li><router-link to="feedback">お客様の声</router-link></li>
          <li><router-link to="interior">整体院風景</router-link></li>
          <li><router-link to="treatment">施術内容</router-link></li>
          <li><router-link to="pressure-point">今月のツボ</router-link></li>
        </ul>
      </div>
    </div>

    <transition name="slide-fade">
      <ul class="menu" v-if="isActive">
        <li class="menu-item">
          <router-link to="faq" v-on:click.native="toggleMenu">よくある質問</router-link>
        </li>
        <li class="divider"></li>
        <li class="menu-item">
          <router-link to="feedback" v-on:click.native="toggleMenu">お客様の声</router-link>
        </li>
        <li class="divider"></li>
        <li class="menu-item">
          <router-link to="interior" v-on:click.native="toggleMenu">整体院風景</router-link>
        </li>
        <li class="divider"></li>
        <li class="menu-item">
          <router-link to="treatment" v-on:click.native="toggleMenu">施術内容</router-link>
        </li>
        <li class="divider"></li>
        <li class="menu-item">
          <router-link to="pressure-point" v-on:click.native="toggleMenu">今月のツボ</router-link>
        </li>
      </ul>
    </transition>

    <div class="hamburger" v-on:click="toggleMenu">
      <button class="c-hamburger c-hamburger--htx" v-bind:class="{'is-active': isActive}">
        <span>toggle menu</span>
      </button>
    </div>
  </div>
</div>
</template>

<script>
   export default {
    data() {
      return {
        isActive: false,
      };
    },
    methods: {
      toggleMenu() {
        if (this.isActive) {
          this.isActive = false;
        }
        else {
          this.isActive = true;
        }
      }
    },
  };
</script>



// WEBPACK FOOTER //
// Headbar.vue?7b0eb621